/* eslint-disable object-curly-newline */
export const fallbackPublications = [
  { category: 'Poetry', title: 'A Bollywood Story', url: 'https://aaww.org/a-bollywood-story/', venue: 'The Margins for Asian American Writer’s Workshop', sortOrder: 1 },
  { category: 'Poetry', title: 'Back Home', url: 'https://www.splitthisrock.org/poetry-database/poem/back-home', venue: 'Poem of the Week Series for Split This Rock', sortOrder: 2 },
  { category: 'Poetry', title: 'Small Endings', url: 'https://www.instagram.com/p/DJFGlv4ykH0/', venue: 'Mississippi Review Art Issue', sortOrder: 3 },
  { category: 'Poetry', title: 'Another Failed Elegy', url: 'https://www.honeyliterary.com/issue-8/poetry-another-failed-elegy-by-gauri-awasthi', venue: 'Honey Literary (Issue 8)', sortOrder: 4 },
  { category: 'Poetry', title: 'Ghazal Split: Memory like Water', url: 'https://sundoglit.com/gauri-awasthi/', venue: 'Sundog Lit', sortOrder: 5 },
  { category: 'Poetry', title: 'Big Brown Boys', venue: 'NELLE Magazine', plainTitle: true, sortOrder: 6 },
  { category: 'Poetry', title: 'Elegy for Living Mothers and Collected Vision', venue: 'Epiphany Magazine', plainTitle: true, sortOrder: 7 },
  { category: 'Poetry', title: 'Self-Portrait with The Taj Mahal', venue: 'Provincetown Arts Magazine', plainTitle: true, sortOrder: 8 },
  { category: 'Poetry', title: 'Ghazal After Babri Masjid and other poems', url: 'https://thepunchmagazine.com/the-byword/poetry/the-poetry-issue-2022-ghazal-after-babri-masjid-and-other-poems', venue: 'Punch Magazine - Special Poetry Issue', sortOrder: 9 },
  { category: 'Poetry', title: 'Mother Wound', url: 'https://www.quarterlywest.com/issue-104-awasthi', venue: 'Quarterly West', sortOrder: 10 },
  { category: 'Poetry', title: 'Lotus-fishing at J.K. Temple', url: 'https://ndreview.nd.edu/archived-issues/ndr-52/', venue: 'Notre Dame Review', suffix: '(Issue 52)', sortOrder: 11 },
  { category: 'Essays and Interviews', title: 'Q&A with Aruni Kashyap, Author of The Way You Want To Be Loved', url: 'https://theoffingmag.com/interviews/qa-with-aruni-kashyap-author-of-the-way-you-want-to-be-loved/', venue: 'The Offing', sortOrder: 1 },
  { category: 'Essays and Interviews', title: 'Q&A with Lynne Thompson, Poet Laureate of Los Angeles', url: 'https://theoffingmag.com/interviews/qa-with-lynne-thompson-author-of-blue-on-a-blue-palette/', venue: 'The Offing', sortOrder: 2 },
  { category: 'Essays and Interviews', title: 'Two Poets Looking: "At Twenty-Eight", Critical Constellations Issue Edited by Yanyi', url: 'https://dilettantearmy.com/articles/two-poets-looking-at-twenty-eight', venue: 'Dilettante Army', sortOrder: 3 },
  { category: 'Essays and Interviews', title: 'Q&A with Jess Yuan: Author of Slow Render', url: 'https://theoffingmag.com/interviews/qa-with-jess-yuan-author-of-slow-render/', venue: 'The Offing', sortOrder: 4 },
  { category: 'Essays and Interviews', title: 'Q&A with Jacqui Germain: Author of Bittering the Wound', url: 'https://theoffingmag.com/interviews/qa-with-jacqui-germain-author-of-bittering-the-wound/', venue: 'The Offing', sortOrder: 5 },
  { category: 'Essays and Interviews', title: 'Q&A with Saba Keramati: Author of Self-Mythology', url: 'https://theoffingmag.com/interviews/qa-with-saba-keramati-author-of-self-mythology/', venue: 'The Offing', sortOrder: 6 },
  { category: 'Essays and Interviews', title: 'Q&A with Sarah Ghazal Ali: Author of Theophanies', url: 'https://theoffingmag.com/interviews/qa-with-sarah-ghazal-ali-author-of-theophanies/', venue: 'The Offing', sortOrder: 7 },
  { category: 'Essays and Interviews', title: 'Q&A with Natasha Rao, Author of Latitude', url: 'https://theoffingmag.com/interviews/qa-with-natasha-rao-author-of-latitude/', venue: 'The Offing', sortOrder: 8 },
  { category: 'Essays and Interviews', title: 'Mitski, Marie Kondo, and Coming Clean: Q&A with Joshua Nguyen', url: 'https://theoffingmag.com/interviews/qa-with-joshua-nguyen-author-of-come-clean/', venue: 'The Offing', sortOrder: 9 },
  { category: 'Essays and Interviews', title: 'Meditations on Grief, Green and Childhood, Interview', url: 'https://therumpus.net/2021/11/01/the-rumpus-interview-with-susan-nguyen/', venue: 'The Rumpus', sortOrder: 10 },
  { category: 'Essays and Interviews', title: 'How The Indian School System Reinforces Gender Norms', url: 'https://livewire.thewire.in/gender-and-sexuality/how-the-indian-school-system-reinforces-gender-norms/', venue: 'The Wire', sortOrder: 11 },
  { category: 'Essays and Interviews', title: 'Women Against CAA, NRC: Breaking the Patriarchy From Within', url: 'https://livewire.thewire.in/politics/women-against-caa-nrc-breaking-the-patriarchy-from-within%E2%80%A8/', venue: 'The Wire', sortOrder: 12 },
  { category: 'Essays and Interviews', title: 'Sixteen Beautiful Untranslatable Hindi Words You Didn’t Know You Needed', url: 'https://bestnewpoets.org', venue: 'Buzzfeed', sortOrder: 13 },
  { category: 'Essays and Interviews', title: 'Five Things We Learnt About Psycho’s Shower Scene', url: 'https://www.filmcompanion.in/features/bollywood-features/psycho-shower-scene-netflix-78-52-alfred-hitchcock/', venue: 'Film Companion', sortOrder: 14 },
  { category: 'Anthologies', title: 'Partition Story', url: 'https://bestnewpoets.org', venue: 'Best New Poets, University of Virginia Press', sortOrder: 1 },
  { category: 'Anthologies', title: 'Yearbook of Indian Poetry in English', url: 'https://bestnewpoets.org', venue: 'Pippa Ran UK', sortOrder: 2 },
  { category: 'Anthologies', prefix: 'Three poems in', title: 'Ninety Seven Poems', url: 'https://www.amazon.in/Ninety-Seven-Poems-Terribly-Tiny-Tales/dp/0143441175', suffix: 'anthology published by', venue: 'Penguin India', sortOrder: 3 },
  { category: 'Anthologies', prefix: 'Three micro-fiction tales in the', title: 'Terribly Tiny Tales', url: 'https://www.amazon.com/Terribly-Tiny-Tales-Vol-I/dp/0143441167', suffix: 'anthology published by', venue: 'Penguin India', sortOrder: 4 },
  { category: 'Podcasts', title: 'Episode 52: Arts Calling Podcast', url: 'https://artscalling.com/2022/07/07/ep-52-gauri-awasthi-editorial-work-dance-and-community-in-poetry/', venue: 'Apple and Spotify Podcasts', separator: ', ', sortOrder: 1 },
  { category: 'Podcasts', title: 'Episode 49: MFA Writers Podcast', url: 'https://www.jaredmccormack.com/mfawriters-gauri-awasthi', venue: 'Apple and Spotify Podcasts', separator: ', ', sortOrder: 2 },
];

export const fallbackEvents = [
  { title: 'Nick Martino presents Scrap Book: Poems, with Gauri Awasthi & Dr. Darius Phelps', url: 'https://www.ptknitwear.com/events', date: 'P&T Knitwear, June 30, 2026', sortOrder: 1 },
  { title: 'Parallel Processes: Interactive Poetry Book Talk and Publishing Workshop', url: 'https://centerforthehumanities.org/event/parallel-processes-poetry-book-talk/', date: 'CUNY Graduate Center New York, New York. April 2026', sortOrder: 2 },
  { title: 'Early Book Launch: Mother Wound', url: 'https://www.instagram.com/p/DXM1XnjEfCP/', date: 'Basket Books & Art, Houston, TX April 2026', sortOrder: 3 },
  { title: 'Ecstasy in Lyric: Contemporary Poetry Of and Beyond Self', url: 'https://nolapoetry.com/node/1598', date: 'New Orleans Poetry Festival, New Orleans, LA April 2026', sortOrder: 4 },
  { title: 'Thursday Night Reading Series', url: 'https://www.instagram.com/p/DXLQafBDS20/?img_index=2', date: 'University of Louisiana, Lafayette, LA April 2026', sortOrder: 5 },
  { title: 'No Rhododendron, Virtual Book Release Party', url: 'https://www.facebook.com/events/692326413188143/?acontext=%7B%22event_action_history%22%3A[%7B%22surface%22%3A%22home%22%7D%2C%7B%22mechanism%22%3A%22attachment%22%2C%22surface%22%3A%22newsfeed%22%7D]%2C%22ref_notif_type%22%3Anull%7D', date: 'October 2025', sortOrder: 6 },
  { title: 'Rehearsal for a Family', url: 'https://www.instagram.com/p/DLyohBlNul0/?hl=en&img_index=6', date: 'June 2025', sortOrder: 7 },
  { title: 'Poets in Conversation', url: 'https://www.instagram.com/p/DIFQf_ePWER/?img_index=1', date: 'The New York Public Library, May 2025', sortOrder: 8 },
  { plainText: 'Astoria Bookshop Reading, April 2025', sortOrder: 9 },
  { plainText: 'Poetry Film Festival of Los Angeles, CA, 2023', sortOrder: 10 },
  { plainText: 'Poetry Panel at C.D. Wright Conference, University of Central Arkansas, Conway, AR, 2022', sortOrder: 11 },
  { plainText: 'Generation Women, Joe’s Pub, Public Theater, New York, NY, 2022', sortOrder: 12 },
  { plainText: 'The Society for Comparative Literature and Arts, Austin, Texas, 2021', sortOrder: 13 },
  { plainText: 'Politics of Protest Panel at South Central Modern Language Association, Houston, 2021', sortOrder: 14 },
  { plainText: 'Action Optimism, Virtual talk and interview at Oxford Climate Society, University of Oxford, 2021', sortOrder: 15 },
  { plainText: 'Action Optimism, Virtual talk and interview at Oxford Climate Society, University of Oxford, 2021', sortOrder: 16 },
  { plainText: 'Paper presentation at Global Souths Conference, University of Louisiana, Lafayette, 2021', sortOrder: 17 },
  { plainText: 'Reader, Hero Foundation Virtual Poetry Showcase for Charity, 2021', sortOrder: 18 },
  { plainText: 'Rewriting Gender in School System with Humans of Safe Places, 2020', sortOrder: 19 },
];

export const fallbackTeaching = [
  { description: 'Poet in Residence, Global Politics and Poetry, University of Houston, Spring 2026', sortOrder: 1 },
  { description: 'Creative Writing Instructor at Writopia Lab, NY, 2025 - Present', sortOrder: 2 },
  { description: 'Teaching Artist, Decolonizing Poetry at Loft Literary, MN, 2024 - 2025', sortOrder: 3 },
  { description: 'Essay Coach (Part-time and Remote) at College Transitions, MN, 2023 – 2025', sortOrder: 4 },
  { description: 'Instructor, Decolonizing Poetry at Barnard College, Columbia University, NY, 2023', sortOrder: 5 },
  { description: 'Visiting Lecturer (English Composition II) at McNeese State University, Lake Charles, LA, 2023', sortOrder: 6 },
  { description: 'Teaching Artist, 5 Week Poetry Workshop: Decolonizing Poetry at Catapult, New York, NY, 2021 – 2023', sortOrder: 7 },
  { description: 'Teaching Artist, Ecopoetics and The Poet at Nebraska Poetry Society (online), 2022', sortOrder: 8 },
  { description: 'Graduate Teaching Assistant (English Composition I & II) at McNeese State University, Lake Charles, LA, 2019 – 2021', sortOrder: 9 },
  { description: 'Writing Center Tutor at McNeese State University, Lake Charles, LA, 2018 – 2019', sortOrder: 10 },
];

/*
 * Kept in step with the Films table in Airtable, which is what the page shows
 * when it can be read. A still named here is the bundled copy the card falls
 * back to when the base cannot be reached; the others carry a video instead.
 */
export const fallbackFilms = [
  {
    title: 'Dhan Ki Devi',
    role: 'Producer',
    imageName: 'dhan-ki-devi.webp',
    description: 'Premiering at Indian Film Festival of Melbourne (IFFM) Dhan Ki Devi follows a day in the life of a child influencer, Ayesha, whose parents have unintentionally traded her innocence in pursuit of social media fame. Using Goddess Lakshmi as a metaphor, the film critiques the commodification of children and the silent loss of childhood in the age of likes and shares.',
    sortOrder: 1,
  },
  {
    title: 'Lotus Fishing at J.K. Temple',
    youtubeUrl: 'https://www.youtube.com/embed/uSyf8wlsJVY',
    role: 'Writer',
    description: 'Lotus Fishing - is a film guided by a poem I wrote, as an older woman speaker revisits her memory of visiting a temple with her grandfather by physically immersing herself in the space, only to find that so much has changed yet remained the same. In this narrative style of storytelling, you find a voice that shapes our earliest understanding of love. "Lotus Fishing at J.K. Temple" was a finalist at the Poetry Film Festival of Los Angeles, at the Theneulithium art gallery in Chicago, and was a semi-finalist at Best Short Fest in Ontario, Canada.',
    sortOrder: 2,
  },
  {
    title: 'Mainawati',
    youtubeUrl: 'https://www.youtube.com/embed/kIUGhblAG0c',
    role: 'Writer',
    description: 'The story of a 13 year old Mainawati, daughter of Nana Saheb, who was instrumental in the first freedom struggle of 1857 in India. Part-oral history and part-academic research, this project is aimed at resurrecting the forgotten stories of the women before us. You can read more about her history',
    linkUrl: 'https://homegrown.co.in/homegrown-creators/a-photoseries-immortalzing-the-noble-sacrifice-of-an-unsung-female-freedom-fighter',
    linkText: 'here',
    sortOrder: 3,
  },
];

/*
 * Prose that is edited in Airtable is stored as HTML under a "_html" key. Links
 * within the site use the hash form the app's HashRouter reads (#/writing), so
 * they navigate without reloading the page.
 */
const aboutBioHtml = `
<p>Gauri Awasthi, born and raised in Kanpur, India, received her MFA in creative writing from McNeese State University. She has won fellowships from <a class="about-link" href="https://yaddo.org/"><i>Yaddo,</i></a> <a class="about-link" href="https://djerassi.org/"><i>Djerassi Resident Artists Program,</i></a> <a class="about-link" href="https://www.middlebury.edu/writers-conferences/writers-conference"><i>Bread Loaf Writers’ Conference,</i></a> <a class="about-link" href="https://www.sundresspublications.com/safta"><i>Sundress Academy for The Arts,</i></a> <a class="about-link" href="https://www.hedgebrook.org/"><i>Hedgebrook,</i></a> <a class="about-link" href="https://communityofwriters.org/"><i>Community of Writers,</i></a> and <a class="about-link" href="https://www.hambidge.org/"><i>Hambidge Center</i></a> where she was a National Endowment For Arts Distinguished Fellow. She lives in New York City, and edits for <a class="about-link" href="https://theoffingmag.com/"><i>The Offing</i></a> and <a class="about-link" href="https://elle.in/"><i>Elle India</i></a>. Her research and creative writing pedagogy is focused on decolonizing poetic forms.</p>
<p>A formally trained Bharatanatyam dancer, she also co-founded <a class="about-link" href="https://www.instagram.com/theveganwardrobe/"><i>The Vegan Wardrobe</i></a> with her sister in 2016, to raise awareness about exploitation of craft and labor from the Global South in the fashion as well as beauty industry. She is reviving this project by building a virtual marketplace that will center handicrafts from India, supporting local artists, under the name <a class="about-link" href="https://duniya.co/"><i>“Duniya”</i></a> – which means world in Hindi.</p>
<p>You can read her published work <a class="about-link" href="#/writing"><i>here</i></a>.</p>
`.trim();

/*
 * The two halves of the Editorial page. A piece carries the section it belongs
 * to; these values are what the Section field in Airtable offers, and they are
 * matched against the columns rather than against the headings, so the headings
 * stay free to be reworded without moving any content.
 */
export const editorialSections = {
  offing: 'The Offing',
  elle: 'Elle India',
};

/*
 * The interviews she is credited with at The Offing, newest first, as the
 * magazine itself lists them. The images are the ones each piece publishes for
 * sharing, and the description is its publication date: the magazine's own
 * summaries are boilerplate and its interviews are not ours to reprint, so a
 * line of her own for each is hers to write in Airtable.
 */
const offingPieces = [
  {
    title: 'Q&A with Mahreen Sohail, author of Small Scale Sinners',
    url: 'https://theoffingmag.com/interviews/qa-with-mahreen-sohail-author-of-small-scale-sinners/',
    description: 'January 2026',
    imageName: 'offing-mahreen-sohail.webp',
    sortOrder: 1,
  },
  {
    title: 'Q&A with Aruni Kashyap, author of The Way You Want To Be Loved',
    url: 'https://theoffingmag.com/interviews/qa-with-aruni-kashyap-author-of-the-way-you-want-to-be-loved/',
    description: 'June 2025',
    imageName: 'offing-aruni-kashyap.webp',
    sortOrder: 2,
  },
  {
    title: 'Q&A with Lynne Thompson, author of Blue on a Blue Palette',
    url: 'https://theoffingmag.com/interviews/qa-with-lynne-thompson-author-of-blue-on-a-blue-palette/',
    description: 'February 2025',
    imageName: 'offing-lynne-thompson.webp',
    sortOrder: 3,
  },
  {
    title: 'Q&A with Jess Yuan, author of Slow Render',
    url: 'https://theoffingmag.com/interviews/qa-with-jess-yuan-author-of-slow-render/',
    description: 'October 2024',
    imageName: 'offing-jess-yuan.webp',
    sortOrder: 4,
  },
  {
    title: 'Q&A with Sarah Ghazal Ali, author of Theophanies',
    url: 'https://theoffingmag.com/interviews/qa-with-sarah-ghazal-ali-author-of-theophanies/',
    description: 'July 2024',
    imageName: 'offing-sarah-ghazal-ali.webp',
    sortOrder: 5,
  },
  {
    title: 'Q&A with Saba Keramati, author of Self-Mythology',
    url: 'https://theoffingmag.com/interviews/qa-with-saba-keramati-author-of-self-mythology/',
    description: 'May 2024',
    imageName: 'offing-saba-keramati.webp',
    sortOrder: 6,
  },
  {
    title: 'Q&A with Jacqui Germain, author of Bittering the Wound',
    url: 'https://theoffingmag.com/interviews/qa-with-jacqui-germain-author-of-bittering-the-wound/',
    description: 'October 2023',
    imageName: 'offing-jacqui-germain.webp',
    sortOrder: 7,
  },
  {
    title: 'Q&A with Natasha Rao, author of Latitude',
    url: 'https://theoffingmag.com/interviews/qa-with-natasha-rao-author-of-latitude/',
    description: 'May 2023',
    imageName: 'offing-natasha-rao.webp',
    sortOrder: 8,
  },
  {
    title: 'Q&A with Joshua Nguyen, author of Come Clean',
    url: 'https://theoffingmag.com/interviews/qa-with-joshua-nguyen-author-of-come-clean/',
    description: 'September 2022',
    imageName: 'offing-joshua-nguyen.webp',
    sortOrder: 9,
  },
];

/*
 * Her magazine work. "imageName" is the file in src/assets that ships with the
 * app: the component uses it when Airtable has no attachment for a piece, and
 * the setup script uses it to upload the image to Airtable in the first place.
 */
const ellePieces = [
  {
    title: 'ELLE Digital Cover Star: Lilly Singh On Breaking Barriers',
    url: 'https://elle.in/elle-digital-cover-star-lilly-singh/',
    description: 'Lilly Singh is not your typical entertainer. Known for her infectious energy and razor-sharp wit, she’s built an empire that goes beyond just comedy. Lilly Singh in conversation with Anamm Inamdar about using humour and heart to tackle global challenges!',
    imageName: 'elle1.webp',
    sortOrder: 1,
  },
  {
    title: 'ELLE City Guide: The Most Stunning Bars In Jaipur',
    url: 'https://elle.in/elle-city-guide-the-most-stunning-bars-in-jaipur/',
    description: 'Drinking in the Pink City, one cool bar at a time',
    imageName: 'elle2.webp',
    sortOrder: 2,
  },
  {
    title: 'In Conversation With K-Pop Star Jay Chang On His New Album Neighborhood, Musical Inspirations and More',
    url: 'https://elle.in/in-conversation-with-k-pop-star-jay-chang/',
    description: 'Music with a dash of nostalgia!',
    imageName: 'elle3.webp',
    sortOrder: 3,
  },
  {
    title: 'Should Fashion Have A Political Voice? Absolutely.',
    url: 'https://elle.in/should-fashion-have-a-political-voice-absolutely/',
    description: 'Now more than ever!',
    imageName: 'elle4.webp',
    sortOrder: 4,
  },
  {
    title: 'ELLE City Guide: Exploring Montreux, Switzerland’s Hidden Gem For Music, History, And Nature',
    url: 'https://elle.in/elle-city-guide-exploring-montreux-switzerlands-hidden-gem-for-music-history-and-nature/',
    description: 'Wake up to lake and mountain views while gorging on alpine food!',
    imageName: 'elle5.webp',
    sortOrder: 5,
  },
  {
    title: 'ELLE Weaves: Erode’s Journey Through The Timeless Art Of Jamakkalam',
    url: 'https://elle.in/fashion/elle-weaves-erodes-journey-through-the-timeless-art-of-jamakkalam-weaving-8594726',
    description: 'Empowering artisans and celebrating craftsmanship, Erode embodies a commitment to slow fashion, sustainability, and empowerment of local artisans.',
    imageName: 'elle6.webp',
    sortOrder: 6,
  },
  {
    title: "Range Rover Unveils Exclusive SV Ranthambore Edition: A Luxurious Tribute to India's Majestic Tiger",
    url: 'https://elle.in/range-rover-unveils-exclusive-sv-ranthambore-edition-a-luxurious-tribute-to-indias-majestic-tiger/',
    description: 'Honouring the spirit of Ranthambore. On Saturday, Range Rover unveiled the New Range Rover SV Ranthambore Edition at the Taj Sawai Palace in Ranthambore',
    imageName: 'elle7.webp',
    sortOrder: 7,
  },
  {
    title: 'Where Chefs In Singapore Like To Dine On Their Day Off',
    url: 'https://ellegourmet.in/food/where-chefs-in-singapore-like-to-dine-on-their-day-off-9639594',
    description: 'An insider’s guide to favourite food finds in the popular Southeast Asian destination, as told by those who know food best.',
    imageName: 'elle8.webp',
    sortOrder: 8,
  },
  {
    title: 'Is Drinking Sea Moss The Ultimate Health And Skin Boost?',
    url: 'https://ellegourmet.in/healthy-lifestyle/is-drinking-sea-moss-the-ultimate-health-and-skin-boost-10533360',
    description: 'With wellness trends evolving, sea moss has emerged as a standout superfood, touted not just for boosting overall health but also for its surprising skin benefits. But can you really drink sea moss for good health? Let’s dive into what the experts say.',
    imageName: 'elle9.webp',
    sortOrder: 9,
  },
  {
    title: 'Eating Your Way Through Prague',
    url: 'https://ellegourmet.in/travel/eating-your-way-through-prague-9680028',
    description: 'Prague is a European gourmet hotspot that you didn’t know about. From avant-garde dining to traditional comfort treats, here are some of the iconic eateries to check out.',
    imageName: 'elle10.webp',
    sortOrder: 10,
  },
  {
    title: 'A Look Inside Louis Vuitton’s New Milan Flagship And Gourmet Experience',
    url: 'https://ellegourmet.in/food/a-look-inside-louis-vuittons-new-milan-flagship-and-gourmet-experience-9651517',
    description: 'Louis Vuitton’s revamped flagship isn’t just a store; it’s Milan’s soul draped in Parisian silk. It’s gastronomy, fashion, and architecture waltzing under a glass ceiling, Milan at its most unapologetically chic.',
    imageName: 'elle11.webp',
    sortOrder: 11,
  },
  {
    title: 'Is Caviar Cool Again?',
    url: 'https://ellegourmet.in/food/is-caviar-cool-again-9649373',
    description: 'With caviar bumps, cocktail pairings, and playful dishes, Indian chefs and restaurateurs are reimagining this luxury delicacy.',
    imageName: 'elle12.webp',
    sortOrder: 12,
  },
  {
    title: 'Una Hacienda: Bengaluru’s Latin American Estate In The Sky',
    url: 'https://ellegourmet.in/drinks/una-hacienda-bengalurus-latin-american-estate-in-the-sky-9679320',
    description: 'From Nikkei-style tiraditos to soulful Mexican pozole, and pisco sours that shimmer with citrus brightness, Una Hacienda celebrates the spirit of Latin America with a menu that feels at once global and grounded.',
    imageName: 'elle13.webp',
    sortOrder: 13,
  },
];

/* Sort Order counts within a column, so the two lists each start at 1. */
export const fallbackEditorial = [
  ...offingPieces.map((piece) => ({ ...piece, section: editorialSections.offing })),
  ...ellePieces.map((piece) => ({ ...piece, section: editorialSections.elle })),
];

/*
 * Photographs for the carousel that opens the Events and Pedagogy pages. "page"
 * decides which page a photo belongs to, and the name doubles as the alt text a
 * screen reader announces, since the carousel shows no captions.
 */
export const fallbackGallery = [
  {
    name: 'Reading outside Unnameable Books under string lights',
    page: 'Events',
    imageName: 'carousel/events-unnameable-reading.webp',
    sortOrder: 1,
  },
  {
    name: 'Teaching a class, a poem on the screen behind her',
    page: 'Pedagogy',
    imageName: 'carousel/pedagogy-classroom.webp',
    sortOrder: 1,
  },
];

/* Stills for the Twenty Eight Days reel; the name doubles as the alt text. */
export const fallbackTwentyEightDaysStills = [
  { name: 'Still 1', imageName: 'twentyeightdays1.jpg', sortOrder: 1 },
  { name: 'Still 2', imageName: 'twentyeightdays2.jpg', sortOrder: 2 },
  { name: 'Still 3', imageName: 'twentyeightdays3.jpg', sortOrder: 3 },
  { name: 'Still 4', imageName: 'twentyeightdays4.jpg', sortOrder: 4 },
  { name: 'Still 5', imageName: 'twentyeightdays5.jpg', sortOrder: 5 },
];

/*
 * The header tabs, in the order they appear. Tick "Hidden" in Airtable to retire
 * a tab without deleting the row; a new row needs a matching route in App to
 * land anywhere. Used as-is whenever Airtable is unreachable, and also when the
 * table comes back empty, since a site with no navigation cannot be used.
 */
export const fallbackNavigation = [
  { label: 'About', path: '/about', sortOrder: 1 },
  { label: 'Mother Wound', path: '/themotherwound', sortOrder: 2 },
  { label: 'Writing', path: '/writing', sortOrder: 3 },
  { label: 'Editorial', path: '/editorial', sortOrder: 4 },
  { label: 'Movies', path: '/movies', sortOrder: 5 },
  { label: 'Pedagogy', path: '/pedagogy', sortOrder: 6 },
  { label: 'Events', path: '/events', sortOrder: 7 },
  { label: 'Contact', path: '/contact', sortOrder: 8 },
];

export const fallbackSiteContent = {
  // The header wordmark alternates between these two.
  home_name: 'Gauri Awasthi',
  home_hindi_name: 'गौरी अवस्थी',

  // Empty on purpose: the row stays in Airtable so a line can be put back above
  // the title, and the home page leaves the space out until one is.
  home_eyebrow: '',
  home_book_title: 'Mother Wound',

  // Empty on purpose: the row stays in Airtable so a line can be put back below
  // the title, and the home page leaves the space out until one is.
  home_book_subtitle: '',
  home_book_description: 'Mother Wound examines the inheritance of trauma through the lens of a daughter. Structured around the rhythm cycle of Indian classical music (SA-RE-GA-MA-PA-DHA-NI-SA, equivalent to Western Solfège), Mother Wound explores the meaning of each note, mirroring the cycle of generational trauma that passes through women.',
  /*
   * The hero draws the quotation marks around a blurb, so these are the bare
   * words. Further endorsements are numbered from two upwards, and the home
   * page reads as many as the base holds: a fourth needs only two more rows,
   * home_blurb_4 and home_blurb_4_author, and no change here.
   *
   * Whatever the matching row in Airtable says takes the place of the words
   * here; these stand when the base cannot be reached.
   */
  home_blurb: 'Bright and Incidental',
  home_blurb_author: 'Eileen Myles, author of Chelsea Girls',
  home_blurb_2: 'This is poetry meant to restore our wholeness...',
  home_blurb_2_author: 'Major Jackson, author of Razzle Dazzle: New & Selected Poems 2002-2022',
  home_blurb_3: 'The attempt of this book is to hold both: what opens and what breaks.',
  home_blurb_3_author: 'Bhanu Kapil, author of Vertical Interrogation of Strangers',
  home_blurb_4: 'Like flowers in a crown, these poems are beautiful and unruly as individuals.',
  home_blurb_4_author: 'Esther Lin, Author of Cold Thief Place',
  home_on_sale: 'On sale October 1, 2026',
  home_preorder_label: 'Pre-order',
  home_preorder_url: 'https://triohousepress.myshopify.com/products/pre-order-mother-wound-by-gauri-awasthi?srsltid=AfmBOooamsx1Z8_0IFQU2jKsCaEhgayNdXarJjp65OoMek4SwXCfUwK-',
  about_heading: 'Poet etc.',
  about_bio_html: aboutBioHtml,

  writing_heading: 'Selected Publications',
  writing_section_poetry: 'Poetry',
  writing_section_essays: 'Essays and Interviews',
  writing_section_anthologies: 'You can buy books I was anthologized in here: (don’t give money to terribly tiny tales though)',
  writing_section_podcasts: 'You can listen to me share my story here:',

  editorial_heading: 'Editorial',
  editorial_intro: 'Gauri has edited widely for magazines and journals, from poetry interviews to features on fashion, food and travel.',

  /*
   * A column each. The heading is the plain title above the list; the intro is
   * the line under it, written as HTML so a link to the magazine can sit inside
   * the sentence; the link label is what the "read it there" link says once a
   * piece is opened.
   */
  editorial_offing_heading: 'The Offing',
  editorial_offing_intro_html: 'Gauri is the Q&amp;A editor at <a href="https://theoffingmag.com/contributor/gauri-awasthi/">The Offing Magazine</a>.',
  editorial_offing_link_label: 'Read at The Offing',
  editorial_elle_heading: 'Elle India',
  editorial_elle_intro_html: 'As a Digital Copyeditor for <a href="https://elle.in/">Elle Magazine</a>, she has edited numerous cover stories, interviews, and features on fashion, food, travel, and more. Here are a few:',
  editorial_elle_link_label: 'Read at Elle India',

  film_28days_logline: 'A 25-year-old New Yorker fears she might be pregnant, forcing her to confront relationships, autonomy, and what it means to choose in a post–Roe v. Wade America.',
  film_28days_note_html: 'Twenty Eight Days has its world premiere at Chelsea Film Festival on Oct 18, 2026. Book your tickets <a class="publication-link" href="https://chelseafilm.org/twenty-eight-days/">here</a> and follow us on <a class="publication-link" href="https://www.instagram.com/p/DdmHA3IJKmS/">social media</a>.',
  events_intro_html: 'Gauri co-hosts <a class="publication-link" href="https://theriverreading.com/">The River Reading Series</a> at Unnameable Books from Spring-Summer, where she co-curates two poets who in turn invite two readers.',
  events_past_heading: 'Past Events',

  pedagogy_heading: 'Pedagogy',

  contact_intro: 'I am available for editing, readings, workshops and speaking engagements. I am also looking for representation! Contact me below:',
  contact_button_label: 'Send',
  contact_success_message: 'Thanks for reaching out. Gauri will get in touch with you shortly.',

  footer_copyright: 'Copyright © 2021 Gauri Awasthi. All Rights Reserved.',
  social_instagram_url: 'https://www.instagram.com/gauriawasthi/',
  social_email: 'gauriawasthi2612@gmail.com',
};

/* Which Site Content key supplies the heading above each publication category. */
export const publicationSectionKeys = {
  Poetry: 'writing_section_poetry',
  'Essays and Interviews': 'writing_section_essays',
  Anthologies: 'writing_section_anthologies',
  Podcasts: 'writing_section_podcasts',
};

/*
 * Site Content keys whose value is an uploaded image rather than text. They are
 * seeded as empty rows so a photo can be dropped into Airtable's Image column;
 * until one is, the component falls back to the image bundled with the app.
 */
export const siteImageKeys = [
  'home_book_image',
  'about_image',
  'film_28days_poster',
  'contact_image',
];

/*
 * Bundled images that the setup script uploads into their Site Content row, so
 * they can be replaced in Airtable.
 */
export const siteImageSeeds = {
  home_book_image: 'mother-wound-cover.jpeg',
  film_28days_poster: 'twenty-eight-days-poster.jpeg',
  contact_image: 'contact-banner.jpg',
};
